import { CONSENT_STORAGE_KEY } from './consent'
import { siteConfig } from './site'

type LocalizedValue = { el: string; en: string }

export const privacyConfig = {
  lastUpdated: '2026-07-23',
  inquiryRetentionMonths: 12,
  controller: {
    name: 'Fotis Mytikas / FM Digital Services',
    email: siteConfig.contact.email,
    location: siteConfig.location,
  },
  providers: {
    netlifyPrivacyUrl: 'https://www.netlify.com/privacy/',
    googlePrivacyUrl: 'https://policies.google.com/privacy',
    viberPrivacyUrl: 'https://www.viber.com/en/terms/viber-privacy-policy/',
  },
  supervisoryAuthority: {
    name: {
      el: 'Αρχή Προστασίας Δεδομένων Προσωπικού Χαρακτήρα',
      en: 'Hellenic Data Protection Authority',
    } satisfies LocalizedValue,
    complaintUrl: 'https://www.dpa.gr/en/individuals/complaint-to-the-hellenic-dpa',
  },
  storage: [
    {
      name: CONSENT_STORAGE_KEY,
      type: 'localStorage',
      provider: { el: 'FM Digital Services / ο browser σας', en: 'FM Digital Services / your browser' } satisfies LocalizedValue,
      purpose: {
        el: 'Αποθηκεύει μόνο την επιλογή Αποδοχής ή Απόρριψης, ώστε το αίτημα συγκατάθεσης να μην εμφανίζεται ξανά χωρίς λόγο.',
        en: 'Stores only the Accept or Reject decision so the consent request is not shown repeatedly without reason.',
      } satisfies LocalizedValue,
      duration: {
        el: 'Μέχρι να αλλάξετε την επιλογή σας ή να διαγράψετε τα δεδομένα του browser.',
        en: 'Until you change your choice or clear browser data.',
      } satisfies LocalizedValue,
      necessary: true,
    },
    {
      name: siteConfig.theme.storageKey,
      type: 'localStorage',
      provider: { el: 'FM Digital Services / ο browser σας', en: 'FM Digital Services / your browser' } satisfies LocalizedValue,
      purpose: {
        el: 'Θυμάται την προαιρετική επιλογή αυτόματου, φωτεινού ή σκοτεινού θέματος μόνο μετά από Αποδοχή.',
        en: 'Remembers the optional automatic, light or dark theme choice only after Accept.',
      } satisfies LocalizedValue,
      duration: {
        el: 'Μέχρι να αλλάξετε το θέμα, να επιλέξετε Απόρριψη ή να διαγράψετε τα δεδομένα του browser.',
        en: 'Until you change the theme, choose Reject or clear browser data.',
      } satisfies LocalizedValue,
      necessary: false,
    },
  ],
} as const
